import React, {useContext, useState,} from 'react';
import {GisContext} from "../context/gis-context.jsx";
import {Card} from "../../../../components/card/card.jsx";
import {Checkbox} from "@headlessui/react";
import GisUtils from "../utils/gis-utils.jsx";
import {getAssetPath} from "../../../../utils/get-asset-path.js";
import {FaLocationDot} from "react-icons/fa6";
import {FaAngleDoubleLeft, FaMap} from "react-icons/fa";

const getIconSizeFromLocalStorage = () => {
    const value = localStorage.getItem("marker-size");

    if (value) return value;

    return "iconZoom2";
}

const GisConfig = ({isOpen, map, mapControls, setMapControls, toggleConfig, markers, geoLayers, geoItems, events}) => {
    const {menu, changeMenu, setGeoLayerChecked, geoLayerChecked} = useContext(GisContext);

    const [size, setSize] = useState(getIconSizeFromLocalStorage());

    const trafficLayer = () => {
        let {trafficLayer, trafficStatus} = mapControls;

        localStorage.setItem('trafficStatus', JSON.stringify({status: !trafficStatus}));

        !trafficStatus ? trafficLayer.setMap(map) : trafficLayer.setMap(null);

        setMapControls({...mapControls, trafficStatus: !trafficStatus});
    }

    const pointsOfInterest = () => {
        const {pointsOfInterest} = mapControls;

        const style = GisUtils.getStyles(mapControls, "POI")

        localStorage.setItem('pointsOfInterest', JSON.stringify({status: !pointsOfInterest}));

        map.setOptions({styles: style});

        setMapControls({...mapControls, pointsOfInterest: !pointsOfInterest});
    }

    const neighborhoodStreets = () => {
        const {neighborhoodStreets} = mapControls;

        const style = GisUtils.getStyles(mapControls, "NEIGHBORHOOD")

        localStorage.setItem('neighborhoodStreets', JSON.stringify({status: !neighborhoodStreets}));

        map.setOptions({styles: style});

        setMapControls({...mapControls, neighborhoodStreets: !neighborhoodStreets});
    }

    const toggleMenuItem = (target) => {
        const newMenu = {...menu};
        let newChecked = [...geoLayerChecked];
        const showInMenu = !menu[target].showInMenu;

        newMenu[target].showInMenu = showInMenu;

        if (target === "point") {
            [...geoItems].forEach(([, marker]) => marker.setVisible(false));

            const geoItemsId = [...events].filter(([, e]) => e.type === "point").map(([, e]) => e.id);
            setGeoLayerChecked(newChecked.filter(item => !geoItemsId.includes(item)));

            newMenu[target].show = false;
        } else if (target === "zone") {
            [...geoLayers].forEach(([, layers]) => layers.forEach(item => item.setVisible(false)));

            const geoLayerIds = [...events].filter(([, e]) => e.type === "zone").map(([, e]) => e.id);
            setGeoLayerChecked(newChecked.filter(item => !geoLayerIds.includes(item)));

            newMenu[target].show = false;
        } else {
            newMenu[target].show = showInMenu;
            [...markers].filter(([,marker]) => marker.type === target).forEach(([, marker]) => marker.setVisible(showInMenu));
        }

        changeMenu(newMenu);
    }

    const handleMarkerSize = (id) => {
        [...markers].forEach(([, marker]) => marker.setIcon(marker[id]));

        setSize(id);
        localStorage.setItem("marker-size", id);
    }

    return (
        <Card id="config" hidden={!isOpen}>
            <Card.Body className="h-full overflow-auto">
                <span className="hide-details" title="Fechar" onClick={toggleConfig}>
                    <FaAngleDoubleLeft />
                </span>
                <h3 className="font-bold mt-1">Configurações</h3>

                <hr className={"text-[#bdbdbd]"}/>
                <h4 className="font-bold mt-1">Habilitar ou desabilitar menu</h4>
                <div className="flex flex-wrap items-center gap-1">
                    {
                        Object.keys(menu).map(key =>
                            <Checkbox
                                key={key}
                                id={key}
                                title={GisUtils.getGroupName(key)}
                                checked={menu[key].showInMenu}
                                className={"group-checkbox" + (menu[key].showInMenu ? " selected" : "")}
                                onClick={() => toggleMenuItem(key)}
                            >
                                <div className="group-image">
                                    {GisUtils.getGroupIcon(key, true)}
                                </div>
                            </Checkbox>
                        )
                    }
                </div>

                <hr className={"text-[#bdbdbd]"}/>
                <h4 className="font-bold mt-1">Tamanho dos marcadores</h4>
                <div className="markers-size flex justify-center gap-2">
                    <button
                        className={"sizes-btn" + (size === 'iconStandard' ? " selected" : "")} id='iconStandard'
                        onClick={() => handleMarkerSize("iconStandard")}
                    >
                        <img src={getAssetPath("img/markers-gis/icon_p.svg")} alt="" style={{"height": "32px"}}/>
                    </button>
                    <button
                        className={"sizes-btn" + (size === 'iconZoom1' ? " selected" : "")} id='iconZoom1'
                        onClick={() => handleMarkerSize("iconZoom1")}
                    >
                        <img src={getAssetPath("img/markers-gis/icon_m.svg")} alt="" style={{"height": "40px"}}/>
                    </button>
                    <button
                        className={"sizes-btn" + (size === 'iconZoom2' ? " selected" : "")} id='iconZoom2'
                        onClick={() => handleMarkerSize("iconZoom2")}
                    >
                        <img src={getAssetPath("img/markers-gis/icon_g.svg")} alt="" style={{"height": "46px"}}/>
                    </button>
                </div>

                <hr className={"text-[#bdbdbd]"}/>
                <h4 className="font-bold mt-1">Detalhes do mapa</h4>
                <div className="map-modes">
                    <button className={"mode-btn " + (mapControls.trafficStatus ? "selected" : "")}
                            onClick={trafficLayer} title="Transito">
                        <div className="mode-icon traffic-icon"></div>
                    </button>
                    <button className={"mode-btn " + (mapControls.pointsOfInterest ? "selected" : "")}
                            onClick={pointsOfInterest} title="Pontos de interesse">
                        <div className="mode-icon content-center">
                            <FaLocationDot size={"36px"}/>
                        </div>
                    </button>
                    <button className={"mode-btn " + (mapControls.neighborhoodStreets ? "selected" : "")}
                            onClick={neighborhoodStreets} title="Ruas e bairros">
                        <div className="mode-icon content-center">
                            <FaMap size={"36px"}/>
                        </div>
                    </button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default GisConfig;